export default function OptionsIcon(props: React.SVGProps<SVGSVGElement>) {
    const { color = '#484854' } = props;
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11.5" cy="7.5" r="1.5" fill={color} />
            <circle cx="11.5" cy="11.5" r="1.5" fill={color} />
            <circle cx="11.5" cy="15.5" r="1.5" fill={color} />
        </svg>
    )
}